<template>
  <page-header-wrapper>
    <div class="back-content">
      <a-tabs
        class="back-content-tabs"
        :default-active-key="selectedTab"
        :active-key="selectedTab"
        :animated="false"
        @change="tabChange"
      >
        <a-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :tab="tab.title"
        >
          <component :is="tab.component" />
        </a-tab-pane>
      </a-tabs>
    </div>
  </page-header-wrapper>
</template>

<script>
import IncludeTax from './includeTax/IncludeTax.vue'
import NotIncludeTax from './notIncludeTax/NotIncludeTax.vue'

const settingTabs = [
  {
    title: '未税收入',
    key: 'notIncludeTax',
    component: 'NotIncludeTax'
  },
  {
    title: '含税收入',
    key: 'includeTax',
    component: 'IncludeTax'
  }
]

export default {
  components: {
    IncludeTax,
    NotIncludeTax
  },
  data () {
    return {
      tabs: settingTabs,
      selectedTab: ''
    }
  },
  watch: {
    '$route.query.tab': {
      handler: function (val) {
        this.setSelectedTab()
      }
    }
  },
  created () {
    this.setSelectedTab()
  },
  methods: {
    setSelectedTab () {
      if (this.$route.query && this.$route.query.tab) {
        this.selectedTab = this.$route.query.tab
      } else {
        this.selectedTab = this.tabs[0].key
      }
    },
    tabChange (activeKey) {
      this.$router.push({
        name: 'summary',
        query: {
          tab: activeKey
        }
      })
    }
  }
}
</script>
